import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_ExpertCalibration_Interface, ExpertCalibration_Interface } from 'src/app/Interface/ExpertCalibration_Interface';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CalibrationService } from 'src/app/Service/Calibration/Calibration.service';
import { ExpertCalibrationService } from 'src/app/Service/ExpertCalibration/ExpertCalibration.service';
import { LabService } from 'src/app/Service/Lab/Lab.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-LabDownloadDeviceForm',
  templateUrl: './LabDownloadDeviceForm.component.html',
  styleUrls: ['./LabDownloadDeviceForm.component.scss']
})
export class LabDownloadDeviceFormComponent implements OnInit {

  Token: String = ""

  Procssing: boolean = false;
  FormSubmitted: boolean = false;


  constructor(
    private Lab_Service: LabService,
    private Calibration_Service: CalibrationService,
    private ExpertCalibration_Service: ExpertCalibrationService,
    private Alertify_Service: AlertifyService,
    private Nav_Service: NavService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token, 8).subscribe(
      data => {
        this.GetDetailDownloadCount()
      }
      , error => {
        localStorage.clear()
        location.reload();
      }
    )
  }


  ResetForm(){
    this.FormSubmitted=false
    this.Info_Download_List=[]
    this.QRCodeInputDownload.nativeElement['value'] = ''
    this.GetDetailDownloadCount()
  }

  DetailDownload:Array<any>=[]
  GetDetailDownloadCount() {
    this.Lab_Service.GetDetailDownloadCount(this.Token).subscribe(
      data => {
        this.DetailDownload=data
      }
    )
  }


  //#region Calibration technician
  modalRef_ExpertCalibration: any;
  Procssing_ExpertCalibration: boolean = false

  Selected_Record_Edit_ExpertCalibration: number = -1

  openModal_ExpertCalibration(template: TemplateRef<any>, ExpertCalibration_Indexer: number) {
    this.modalRef_ExpertCalibration = this.modalService.show(template);
    this.Selected_Record_Edit_ExpertCalibration = ExpertCalibration_Indexer
  }

  ExpertCalibrationpage: number = 0;
  Filter_Familly: string = ''
  Filter_Area: string = ''

  Change_Filter() {
    this.ExpertCalibrationpage = 0
  }

  ReadData_ExpertCalibration() {
    this.Procssing_ExpertCalibration = true

    this.ExpertCalibration_Service.GetActiveList(this.Token,true,false,true).subscribe(
      data => {
        this.DataList_ExpertCalibration = data
        this.Procssing_ExpertCalibration = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  Data_Seleted_ExpertCalibration: ExpertCalibration_Interface = Empty_ExpertCalibration_Interface()
  DataList_ExpertCalibration: Array<ExpertCalibration_Interface> = []

  Set_Selected_ExpertCalibration_Record(item) {
    this.modalRef_ExpertCalibration.hide()
    this.Data_Seleted_ExpertCalibration = item

    this.QRCodeInputDownload.nativeElement.focus();
  }

  //#endregion


  //#region Download
  Info_Download_List: Array<General_Interface> = []
  @ViewChild('QRCodeInputDownload') QRCodeInputDownload: ElementRef;

  QRCodeInputDownload_Enter() {
    this.Get_Calibration_Info_Download(this.QRCodeInputDownload.nativeElement['value'])
  }

  Get_Calibration_Info_Download(QRCodeInput: string) {

    if (!this.Procssing) {
      this.Procssing = true
      this.Calibration_Service.GetInfobyQR(this.Token, QRCodeInput).subscribe(
        data => {

          this.Procssing = false
          this.QRCodeInputDownload_Esc()

          if (data.id == -1) {
            this.Alertify_Service.ErrorMessage("The scanned QR code is invalid.")
          }
          else if (this.Info_Download_Exist(data)) {
            this.Alertify_Service.ErrorMessage("The scanned QR code already exists in the list.")
          }
          else {
            data.dsc=QRCodeInput
            this.Info_Download_List.push(data)
            this.Alertify_Service.SuccessMessage("Instrument information loaded successfully.")
          }

        }, error => {
          this.Procssing = false
          this.Alertify_Service.ErrorMessage("The scanned QR code is invalid.")

        }
      )
    }

  }

  QRCodeInputDownload_Esc() {
    this.QRCodeInputDownload.nativeElement['value'] = ''
  }

  Info_Download_Exist(input: General_Interface) {
    for (let item of this.Info_Download_List) {
      if (item.dsc == input.dsc) {
        return true
      }
    }
    return false
  }

  Info_Download_Remove(id: number) {
    this.Info_Download_List.splice(id, 1)
    this.Alertify_Service.SuccessMessage("Deleted successfully.")
    this.QRCodeInputDownload.nativeElement.focus();
  }


  QRCodeChangeDownload() {
    this.Procssing = true

    var Code: Array<string> = []
    for (let item of this.Info_Download_List) {
      Code.push(item.dsc)
    }

    this.Lab_Service.PostDownload(Code, this.Data_Seleted_ExpertCalibration.id, this.Token).subscribe(
      data => {

        this.Procssing = false
        this.QRCodeInputDownload_Esc()
        this.Info_Download_List = data

        this.FormSubmitted=true
        this.Alertify_Service.SuccessMessage("The instruments were checked for entry.")

      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }


  //#endregion

}
